const TMA_HOSTS = new Set([
  'app.shot.band',
  'app.cs-shot.pro',
  'app.cs-shot.uz',
  'app-dev1.shot.band',
  'app-dev1.cs-shot.pro',
  'ultrathink.cs-shot.pro',
]);

export function isTmaHost(host: string): boolean {
  if (!host) return false;
  const colonIdx = host.indexOf(':');
  const hostname = colonIdx >= 0 ? host.slice(0, colonIdx) : host;
  return TMA_HOSTS.has(hostname);
}

const WEB_HOSTS = new Set([
  'shot.band',
  'cs-shot.pro',
  'cs-shot.uz',
  'dev1.shot.band',
  'dev1.cs-shot.pro',
]);

export function webOrigin(host: string | null): string | null {
  if (!host) return null;
  const colonIdx = host.indexOf(':');
  const hostname = colonIdx >= 0 ? host.slice(0, colonIdx) : host;
  return WEB_HOSTS.has(hostname) ? `https://${hostname}` : null;
}

export function isCsShotUzHost(host: string): boolean {
  if (!host) return false;
  const colonIdx = host.indexOf(':');
  const hostname = colonIdx >= 0 ? host.slice(0, colonIdx) : host;
  return hostname === 'cs-shot.uz' || hostname.endsWith('.cs-shot.uz');
}

export type Runtime = 'tma' | 'web';
